<template>
  <div>
    <TitleSlot :title="headTitle" ></TitleSlot>
    <div class="wrapper">
      <ul class="l" v-if="advLeft.length>0">
        <li v-for="(item,index) in advLeft" :key="index" :class="advLeft.length == 1 ? 'one' : 'two' ">
          <a :href="item.val" v-if="item.cat==1">
            <img :src="item.image" alt>
          </a>
          <router-link :to="{name:'help',query: {article_id:item.val}}" v-if="item.cat==2">
            <img :src="item.image" alt>
          </router-link>
          <router-link :to="{name:'detail',params: {goodsId:item.val}}" v-if="item.cat==3">
            <img :src="item.image" alt>
          </router-link>
        </li>
      </ul>
      <div class="r">
        <LoftRow :row="advLeft.length == 0 ? '' : 'row-4' " :list="list" :nums="nums"></LoftRow>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSlot from "@/components/home/TitleSlot.vue";
import LoftRow from "@/components/video/LoftRow.vue";

export default {
  name: "ProductLoft",
  components: { TitleSlot, LoftRow },
  props: {
    headTitle: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    advLeft: {
      type: Array,
      default: function() {
        return [];
      }
    },
    keyword: {
      type: String,
      default: ""
    },
    nums: {
      type: [Number, String],
      default: -1
    }
  },
  computed: {
    slotArr() {
      return this.keyword.split(" ");
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrapper {
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  height: 688px;
  overflow: hidden;
  .l {
    width: 234px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 14px;
    margin-right: 14px;
    li {
      &.one {
        height: 100%;
      }
      &.two {
        height: 330px;
      }
      a {
        display: block;
        width: 234px;
        height: 100%;
        transition: all 0.25s;
        &:hover {
          transform: translateY(-3px);
          box-shadow: 1px 1px 20px #999;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .r {
    flex: 1;
    overflow: hidden;
  }
}
</style>